var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEdit = function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.948,
    height: 13.019,
    viewBox: "0 0 12.948 13.019",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842",
    transform: "translate(-652.292 -495.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841",
    transform: "translate(652.344 495.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834",
    transform: "translate(1.728 2.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M661.783,512.473l-2.985-2.985a.1.1,0,0,1,0-.145l5.749-5.749a.1.1,0,0,1,.145,0l2.985,2.985a.1.1,0,0,1,0,.145l-5.75,5.749A.1.1,0,0,1,661.783,512.473Zm-2.768-3.058,2.841,2.841,5.6-5.6-2.84-2.84Z",
    transform: "translate(-658.768 -503.564)",
    fill: "#949494",
    stroke: "#707070",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835",
    transform: "translate(7.109 0.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M681.788,503.286,678.8,500.3a.1.1,0,0,1,0-.145l1.769-1.769a.1.1,0,0,1,.145,0l2.985,2.985a.1.1,0,0,1,0,.145l-1.769,1.769A.1.1,0,0,1,681.788,503.286Zm-2.768-3.057,2.841,2.84,1.624-1.624-2.84-2.841Z",
    transform: "translate(-678.773 -498.357)",
    fill: "#949494",
    stroke: "#707070",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836",
    transform: "translate(8.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M688.39,499.594l-2.948-2.948a.1.1,0,0,1,0-.147l.251-.251a1.589,1.589,0,0,1,2.18-.119l.908.909a1.743,1.743,0,0,1,.008,2.306l-.251.251A.1.1,0,0,1,688.39,499.594Zm-2.728-3.022,2.8,2.8.177-.177a1.542,1.542,0,0,0-.007-2.011l-.909-.908a1.394,1.394,0,0,0-1.885.118Z",
    transform: "translate(-685.411 -495.75)",
    fill: "#949494",
    stroke: "#707070",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837",
    transform: "translate(7.49 1.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M683.2,503.873l-2.986-2.985a.1.1,0,0,1,0-.145l1.032-1.032a.1.1,0,0,1,.145,0l2.985,2.985a.1.1,0,0,1,0,.145l-1.032,1.032A.1.1,0,0,1,683.2,503.873Zm-2.769-3.057,2.841,2.84.887-.887-2.84-2.841Z",
    transform: "translate(-680.189 -499.681)",
    fill: "#949494",
    stroke: "#707070",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838",
    transform: "translate(2.704 3.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M663.46,515.153l-1.032-1.032a.1.1,0,0,1,0-.145l5.381-5.381a.1.1,0,0,1,.145,0l1.032,1.032a.1.1,0,0,1,0,.145l-5.381,5.381A.1.1,0,0,1,663.46,515.153Zm-.814-1.1.887.887,5.236-5.236-.887-.887Z",
    transform: "translate(-662.398 -508.565)",
    fill: "#949494",
    stroke: "#707070",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839",
    transform: "translate(0 7.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M652.374,529.969a.1.1,0,0,1-.024-.108L654.076,525a.1.1,0,0,1,.172-.039l2.985,2.985a.1.1,0,0,1-.035.171l-4.711,1.873a.1.1,0,0,1-.111-.022Zm1.843-4.742-1.594,4.486,4.35-1.73Z",
    transform: "translate(-652.344 -524.933)",
    fill: "#949494",
    stroke: "#707070",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840",
    transform: "translate(0.174 11.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M653.365,538.99l-.375,1.171,1.137-.41Z",
    transform: "translate(-652.99 -538.99)",
    fill: "#949494",
    stroke: "#707070",
    strokeWidth: 0.1
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_edit.d4985539.svg";
export { ForwardRef as ReactComponent };